import Vue from 'vue'
import Router from 'vue-router'
import service from './services/logacesso'

Vue.use(Router)

// document.addEventListener('DOMContentLoaded', () => {
//   try {
//     const lastUnload = sessionStorage.getItem('lastUnload')

//     if (!lastUnload) {
//       localStorage.clear()
//     } else {
//       console.log('Reload detectado — storage mantido')
//     }

//     sessionStorage.setItem('lastUnload', Date.now())
//   } catch (e) {
//     console.warn('Erro ao acessar storage:', e)
//   }
// })

// window.addEventListener('beforeunload', () => {
//   try {
//     if (sessionStorage.getItem('lastUnload')) {
//       console.log('Unload detectado — storage mantido')
//     } else {
//       sessionStorage.setItem('lastUnload', Date.now())
//     }
//   } catch (e) {}
// })

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: '/login',
          component: () => import('@/views/pages/Login'),
        },
        {
          name: 'Verify',
          path: '/verify/:link',
          component: () => import('@/views/pages/VerificarEmpresa'),
        },
        {
          name: 'VerifyPwa',
          path: '/verifyPwa/:link',
          component: () => import('@/views/pages/VerificarEmpresaPwa'),
        },
        {
          name: 'Recover',
          path: '/recover',
          component: () => import('@/views/pages/Recover'),
        },
        {
          name: 'ResetPassword',
          path: '/recover/:link',
          component: () => import('@/views/pages/Recover'),
        },
      ],
    },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Principal',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'cadastro-usuario',
          path: '/usuarios/cadastro-usuario',
          component: () => import('@/views/dashboard/forms/Sistema/CadastroUsuarioForm'),
        },
        {
          name: 'lista-usuario',
          path: '/usuarios/lista-usuarios',
          component: () => import('@/views/dashboard/forms/Sistema/ListaUsuarioForm'),
        },
        {
          name: 'gestao-comercial',
          path: '/gestao-comercial',
          component: () => import('@/views/dashboard/forms/Comercial/ComercialForm'),
        },
        {
          name: 'gestao-comercial2',
          path: '/gestao-comercial2',
          component: () => import('@/views/dashboard/forms/Comercial/Comercial2Form'),
        },
        {
          name: 'gestao-comercial3',
          path: '/gestao-comercial3',
          component: () => import('@/views/dashboard/forms/Comercial/ComercialLeiteIcmsstForm'),
        },
        {
          name: 'gestao-comercial4',
          path: '/gestao-comercial4',
          component: () => import('@/views/dashboard/forms/Comercial/Comercial4Form'),
        },
        {
          name: 'Comercial',
          path: '/comercial',
          component: () => import('@/views/dashboard/forms/Comercial/Comercial5Form'),
        },
        {
          name: 'gestao-comercial6',
          path: '/gestao-comercial6',
          component: () => import('@/views/dashboard/forms/Comercial/Comercial6Form'),
        },
        {
          name: 'gestao-comercial7',
          path: '/gestao-comercial7',
          component: () => import('@/views/dashboard/forms/Comercial/Comercial7Form'),
        },
        {
          name: 'vendas',
          path: '/vendas',
          component: () => import('@/views/dashboard/forms/Comercial/VendasForm'),
        },
        {
          name: 'vendas2',
          path: '/vendas2',
          component: () => import('@/views/dashboard/forms/Comercial/Vendas2Form'),
        },
        {
          name: 'vendas3',
          path: '/vendas3',
          component: () => import('@/views/dashboard/forms/Comercial/Vendas3Form'),
        },
        {
          name: 'vendas4',
          path: '/vendas4',
          component: () => import('@/views/dashboard/forms/Comercial/Vendas4Form'),
        },
        {
          name: 'detalhe-principais-clientes',
          path: '/vendas/detalhe-principais-clientes',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas/DetalhePrincipaisCliente'),
        },
        {
          name: 'detalhe-principais-clientes3',
          path: '/somenteclientes3/detalhe-principais-clientes3',
          component: () => import('@/views/dashboard/components/comercial/somenteCliente3/DetalheFaturamentoPrincipaisCliente3'),
        },
        {
          name: 'detalhe-vendas3-principais-clientes',
          path: '/vendas3/detalhe-principais-clientes',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas3/DetalheVendas3PrincipaisCliente'),
        },
        {
          name: 'detalhe-faturamento-grupo-produtos',
          path: '/vendas/detalhe-faturamento-grupo-produtos',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas/DetalheFaturamentoGrupoProdutos'),
        },
        {
          name: 'detalhe-faturamento-classificacao-produtos',
          path: '/vendas/detalhe-faturamento-classificacao-produtos',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas/DetalheFaturamentoClassificacaoProdutos'),
        },
        {
          name: 'detalhe-faturamento-produtos',
          path: '/vendas/detalhe-faturamento-produtos',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas/DetalheFaturamentoProdutos'),
        },
        {
          name: 'detalhe-vendas3-faturamento-produtos',
          path: '/vendas3/detalhe-faturamento-produtos',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas3/DetalheVendas3FaturamentoProdutos'),
        },
        {
          name: 'detalhe-vendas3-devolucao',
          path: '/vendas3/detalhe-vendas3-devolucao',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas3/DetalheVendas3Devolucao'),
        },
        {
          name: 'detalhe-vendas3-devolucao-ano-anterior',
          path: '/vendas3/detalhe-vendas3-devolucao-ano-anterior',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheVendas3/DetalheVendas3DevolucaoAnoAnterior'),
        },
        {
          name: 'pedidos',
          path: '/pedidos',
          component: () => import('@/views/dashboard/forms/Comercial/PedidosForm'),
        },
        {
          name: 'time',
          path: '/time',
          component: () => import('@/views/dashboard/forms/Comercial/TimeForm'),
        },
        {
          name: 'time2',
          path: '/time2',
          component: () => import('@/views/dashboard/forms/Comercial/Time2Form'),
        },
        {
          name: 'time3',
          path: '/time3',
          component: () => import('@/views/dashboard/forms/Comercial/Time3Form'),
        },
        {
          name: 'time4',
          path: '/time4',
          component: () => import('@/views/dashboard/forms/Comercial/Time4Form'),
        },
        {
          name: 'participantes',
          path: '/participantes',
          component: () => import('@/views/dashboard/forms/Comercial/ClientesForm'),
        },
        {
          name: 'detalhe-cliente-sem-faturamento',
          path: '/clientes/detalhe-cliente-sem-faturamento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClientesSemFaturamento'),
        },
        {
          name: 'detalhe-cliente-proximo-inativar',
          path: '/clientes/detalhe-cliente-proximo-inativar',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClientesProximoInativar'),
        },
        {
          name: 'detalhe-cliente-dados-devolucoes',
          path: '/clientes/detalhe-cliente-dados-devolucoes',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClientesDadosDevolucoes'),
        },
        {
          name: 'detalhe-cliente-perfomance-ticket-medio',
          path: '/clientes/detalhe-cliente-perfomance-ticket-medio',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClientesPerfomanceTicketMedio'),
        },
        {
          name: 'detalhe-cliente-maiores-crescimento',
          path: '/clientes/detalhe-cliente-maiores-crescimento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClientesMaioresCrescimento'),
        },
        {
          name: 'detalhe-cliente-piores-crescimento',
          path: '/clientes/detalhe-cliente-piores-crescimento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClientesPioresCrescimento'),
        },
        {
          name: 'somente-clientes',
          path: '/somenteclientes',
          component: () => import('@/views/dashboard/forms/Comercial/SomenteClientesForm'),
        },
        {
          name: 'somente-clientes2',
          path: '/somenteclientes2',
          component: () => import('@/views/dashboard/forms/Comercial/SomenteClientes2Form'),
        },
        {
          name: 'somente-clientes3',
          path: '/somenteclientes3',
          component: () => import('@/views/dashboard/forms/Comercial/SomenteClientes3Form'),
        },
        {
          name: 'somente-clientes4',
          path: '/somente-clientes4',
          component: () => import('@/views/dashboard/forms/Comercial/SomenteClientes4Form'),
        },
        {
          name: 'detalhe-clientes-faturado',
          path: '/clientes/detalhe-clientes-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheClienteFaturado'),
        },
        {
          name: 'detalhe-total-clientes',
          path: '/clientes/detalhe-total-clientes',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheTotalCliente'),
        },
        {
          name: 'detalhe-novos-clientes-faturado',
          path: '/clientes/detalhe-novos-clientes-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheNovosClienteFaturado'),
        },
        {
          name: 'detalhe-melhores-clientes-faturado',
          path: '/clientes/detalhe-melhores-clientes-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheMelhoresClienteFaturado'),
        },
        {
          name: 'detalhe-cliente-faturado',
          path: '/cliente/detalhe-cliente-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesFaturado'),
        },
        {
          name: 'detalhe-cliente-sem-faturado',
          path: '/cliente/detalhe-cliente-sem-faturamento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesSemFaturado'),
        },
        {
          name: 'detalhe-total-cliente',
          path: '/cliente/detalhe-total-cliente',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheTotalClientes'),
        },
        {
          name: 'detalhe-novos-cliente-faturado',
          path: '/cliente/detalhe-novos-cliente-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheNovosClientesFaturado'),
        },
        {
          name: 'detalhe-melhores-cliente-faturado',
          path: '/cliente/detalhe-melhores-cliente-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheMelhoresClientesFaturado'),
        },
        {
          name: 'detalhe-cliente-sem-faturamento2',
          path: '/somenteclientes/detalhe-cliente-sem-faturamento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheSomenteClientesSemFaturamento'),
        },
        {
          name: 'detalhe-cliente-proximo-inativar2',
          path: '/somenteclientes/detalhe-cliente-proximo-inativar',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheSomenteClientesProximoInativar'),
        },
        {
          name: 'detalhe-cliente-devolucao',
          path: '/somenteclientes/detalhe-cliente-devolucao',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesDevolucaoImpropria'),
        },
        {
          name: 'detalhe-cliente4-devolucao',
          path: '/somenteclientes4/detalhe-cliente-devolucao',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes4/DetalheClientes4Devolucao'),
        },
        {
          name: 'detalhe-cliente-devolucao-nff',
          path: '/somenteclientes/detalhe-cliente-devolucao-nff',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesDevolucaoImpropriaNFF'),
        },
        {
          name: 'detalhe-cliente-dados-perfomance',
          path: '/somenteclientes/detalhe-cliente-dados-perfomance',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesDadosPerfomance'),
        },
        {
          name: 'detalhe-cliente-dados-maiores-crescimento',
          path: '/somenteclientes/detalhe-cliente-dados-maiores-crescimento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesDadosMaioresClientes'),
        },
        {
          name: 'detalhe-cliente-dados-piores-crescimento',
          path: '/somenteclientes/detalhe-cliente-dados-piores-crescimento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheClientesDadosPioresClientes'),
        },
        {
          name: 'clientes-rfv-faturado',
          path: '/clientes/clientes-rfv-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/ClienteRFV'),
        },
        {
          name: 'extrato-clientes-faturado',
          path: '/clientes/extrato-clientes-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/ExtratoCliente'),
        },
        {
          name: 'detalhe-mix-comprado',
          path: '/clientes/extrato-clientes-faturado/detalhe-mix-comprado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheTableMixComprado'),
        },
        {
          name: 'detalhe-clientes-produtos-vender',
          path: '/clientes/extrato-clientes-faturado/detalhe-produtos-vender',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheExtradoClienteProdutosVender'),
        },
        {
          name: 'detalhe-clientes-produtos-focar',
          path: '/clientes/extrato-clientes-faturado/detalhe-produtos-focar',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/DetalheExtradoClienteProdutosFocar'),
        },
        {
          name: 'abc-clientes-faturado',
          path: '/clientes/abc-clientes-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheCliente/ABCCliente'),
        },
        {
          name: 'cliente-rfv-faturado',
          path: '/cliente/cliente-rfv-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/ClientesRFV'),
        },
        {
          name: 'extrato-cliente-faturado',
          path: '/cliente/extrato-cliente-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/ExtratoClientes'),
        },
        {
          name: 'extrato-somente-cliente-faturado',
          path: '/somentecliente/extrato-cliente',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/ExtratoClientes2'),
        },
        {
          name: 'extrato-somente-detalhe-mix-comprado',
          path: '/somenteclientes/detalhe-mix-comprado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheExtradoSomentoClienteMixComercializado'),
        },
        {
          name: 'extrato-somente-detalhe-produtos-vender',
          path: '/somenteclientes/detalhe-produtos-vender',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheExtradoSomentoClienteProdutosVender'),
        },
        {
          name: 'extrato-somente-detalhe-produtos-focar',
          path: '/somenteclientes/detalhe-produtos-focar',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheExtradoSomentoClienteProdutosFocar'),
        },
        {
          name: 'abc-cliente-faturado',
          path: '/cliente/abc-cliente-faturado',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/ABCClientes'),
        },
        {
          name: 'analise-faturamento',
          path: '/analise-faturamento',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseFaturamentoForm'),
        },
        {
          name: 'analise-vendas',
          path: '/analise-vendas',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseEquipeVendasForm'),
        },
        {
          name: 'analise-vendedor',
          path: '/analise-vendedor',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseVendasVendedoresForm'),
        },
        {
          name: 'analise-redes',
          path: '/analise-redes',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseVendasRedesForm'),
        },
        {
          name: 'detalhe-analise-vendas',
          path: '/analise-vendas/detalhe-analise-vendas',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheAnaliseEquipeVendas/DetalheCoberturaVendedor'),
        },
        {
          name: 'detalhe-time-analise-vendas',
          path: '/time/detalhe-analise-vendas',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheTime/DetalheCoberturaTime'),
        },
        {
          name: 'detalhe-time4-analise-vendas',
          path: '/time4/detalhe-analise-vendas',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheTime4/DetalheCoberturaTime4'),
        },
        {
          name: 'fluxo-caixa',
          path: '/fluxo-caixa',
          component: () => import('@/views/dashboard/forms/Financeiro/FluxoCaixaForm'),
        },
        {
          name: 'fluxocaixa',
          path: '/fluxocaixa',
          component: () => import('@/views/dashboard/forms/Financeiro/FluxoCaixa2Form'),
        },
        {
          name: 'contas-receber',
          path: '/contas-receber',
          component: () => import('@/views/dashboard/forms/Financeiro/ContasReceberForm'),
        },
        {
          name: 'detalhe-valor-a-receber',
          path: '/contas-receber/valor-a-receber',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasReceber/DetalheValorAReceberForm'),
        },
        {
          name: 'detalhe-valor-recebido',
          path: '/contas-receber/valor-recebido',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasReceber/DetalheValorRecebidoForm'),
        },
        {
          name: 'detalhe-valor-aberto',
          path: '/contas-receber/valor-aberto',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasReceber/DetalheValorAbertoForm'),
        },
        {
          name: 'detalhe-valor-vencido',
          path: '/contas-receber/valor-vencido',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasReceber/DetalheValorVencidoForm'),
        },
        {
          name: 'detalhe-historico-inadimplencia',
          path: '/contas-receber/detalhamento-inadimplencia',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasReceber/DetalheHistoricoInadimplenciaForm'),
        },
        {
          name: 'detalhe-historico-inadimplencia-clientes',
          path: '/contas-receber/detalhamento-inadimplencia-clientes',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasReceber/DetalheHistoricoInadimplenciaClientesForm'),
        },
        {
          name: 'contas-pagar',
          path: '/contas-pagar',
          component: () => import('@/views/dashboard/forms/Financeiro/ContasPagarForm'),
        },
        {
          name: 'detalhe-valor-a-pagar',
          path: '/contas-pagar/valor-a-pagar',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasPagar/DelhamentoContasAPagar'),
        },
        {
          name: 'detalhe-valor-pago',
          path: '/contas-pagar/valor-pago',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasPagar/DelhamentoContasPagas'),
        },
        {
          name: 'detalhe-valor-a-vencer',
          path: '/contas-pagar/valor-a-vencer',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasPagar/DelhamentoContasAVencer'),
        },
        {
          name: 'detalhe-valor-pagar-vencido',
          path: '/contas-pagar/valor-pagar-vencido',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasPagar/DelhamentoContasPagarVencido'),
        },
        {
          name: 'detalhe-ranking-fornecedores',
          path: '/contas-pagar/detalhe-ranking-fornecedores',
          component: () => import('@/views/dashboard/forms/Financeiro/PaginasDetalhamentoContasPagar/DelhamentoRankingFornecedores'),
        },
        {
          name: 'preco-medio',
          path: '/preco-medio',
          component: () => import('@/views/dashboard/forms/Comercial/PrecoMedioForm'),
        },
        {
          name: 'volume-preco',
          path: '/volume-preco',
          component: () => import('@/views/dashboard/forms/Comercial/VolumePrecoForm'),
        },
        {
          name: 'linha-producao',
          path: '/linha-producao',
          component: () => import('@/views/dashboard/forms/Comercial/LinhaProducaoForm'),
        },
        {
          name: 'fluxo-venda',
          path: '/fluxo-venda',
          component: () => import('@/views/dashboard/forms/Comercial/FluxoVendaForm'),
        },
        {
          name: 'positivacao-cliente',
          path: '/positivacao-cliente',
          component: () => import('@/views/dashboard/forms/Comercial/PositicaoClienteForm'),
        },
        {
          name: 'mix-cliente',
          path: '/mix-cliente',
          component: () => import('@/views/dashboard/forms/Comercial/MixClienteForm'),
        },
        {
          name: 'base-atendimento',
          path: '/base-atendimento',
          component: () => import('@/views/dashboard/forms/Comercial/BaseAtendimentoForm'),
        },
        {
          name: 'controle-preco',
          path: '/controle-preco',
          component: () => import('@/views/dashboard/forms/Comercial/ControlePrecoForm'),
        },
        {
          name: 'mix-medio',
          path: '/mix-medio',
          component: () => import('@/views/dashboard/forms/Comercial/MixMedioForm'),
        },
        {
          name: 'devolucao',
          path: '/devolucao',
          component: () => import('@/views/dashboard/forms/Comercial/DevolucaoForm'),
        },
        {
          name: 'vendedor',
          path: '/vendedor',
          component: () => import('@/views/dashboard/forms/Comercial/VendedorForm'),
        },
        {
          name: 'consultor-vendas',
          path: '/consultor-vendas',
          component: () => import('@/views/dashboard/forms/Comercial/ConsultorVendasForm'),
        },
        {
          name: 'informacoes',
          path: '/informacoes',
          component: () => import('@/views/dashboard/forms/Sistema/ListaInformacoesForm'),
        },
        {
          name: 'manifesto-saida',
          path: '/manifesto-saida',
          component: () => import('@/views/dashboard/forms/Comercial/ManifestoSaidaForm'),
        },
        {
          name: 'detalhe-base-atendimento',
          path: '/cliente/base-atendimento',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheSomenteClientes/DetalheBaseAtendimento'),
        },
        {
          name: 'analise-produto',
          path: '/analise-produto',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseProdutoForm'),
        },
        {
          name: 'Analise Produtos',
          path: '/analise-produto3',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseProduto3Form'),
        },
        {
          name: 'analise-produto4',
          path: '/analise-produto4',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseProduto4Form'),
        },
        {
          name: 'analise-produto5',
          path: '/analise-produto5',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseProduto5Form'),
        },
        {
          name: 'produtos-nao-comercializados',
          path: '/analise-produto5/produtos-nao-comercializados',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheAnaliseProdutos5/DetalheProdutosNaoComercializados'),
        },
        {
          name: 'detalhe-grupo-itens',
          path: '/analise-produto5/detalhe-grupo-itens',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheAnaliseProdutos5/DetalheGrupoItens'),
        },
        {
          name: 'producao-simples',
          path: '/producao-simples',
          component: () => import('@/views/dashboard/forms/Industrial/ProducaoSimplesForm'),
        },
        {
          name: 'produtores',
          path: '/produtores',
          component: () => import('@/views/dashboard/forms/Produtores/ProdutoresForm'),
        },
        {
          name: 'detalhe-produtores-positivados',
          path: '/produtores/detalhe-produtores-positivados',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheProdutores/DetalheProdutoresPositivados'),
        },
        {
          name: 'detalhe-produtores-ativos',
          path: '/produtores/detalhe-produtores-ativos',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheProdutores/DetalheProdutoresAtivos'),
        },
        {
          name: 'detalhe-entregaleite-novos-produtores',
          path: '/produtores/detalhe-entregaleite-novos-produtores',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheProdutores/DashboardDetalhamentoEntregaNovosProdutores'),
        },
        {
          name: 'detalhe-melhores-entregasleite-produtores',
          path: '/produtores/detalhe-melhores-entregasleite-produtores',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheProdutores/DetalheMelhoresEntregasLeiteProdutores'),
        },
        {
          name: 'detalhe-melhores-entregasleite-linhasleite',
          path: '/produtores/detalhe-melhores-entregasleite-linhasleite',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheProdutores/DetalheMelhoresEntregasLeiteLinhasLeite'),
        },
        {
          name: 'Páginas',
          path: '/pagina',
          component: () => import('@/views/dashboard/forms/Sistema/PaginasForm'),
        },
        {
          name: 'detalhe-time-cobertura',
          path: '/time/detalhe-time-cobertura',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheTime/DetalheCoberturaTimePersonalizado'),
        },
        {
          name: 'detalhe-time3-cobertura',
          path: '/time3/detalhe-time-cobertura',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheTme3/DetalheCoberturaTime3'),
        },
        {
          name: 'Cliente',
          path: '/cliente',
          component: () => import('@/views/dashboard/forms/Comercial/ClienteForm'),
        },
        {
          name: 'Análise Produtos',
          path: '/analisa-produto2',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseProduto2Form'),
        },
        {
          name: 'Análise Margem',
          path: '/analise-margem',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseMargemForm'),
        },
        {
          name: 'Análise Margem 2',
          path: '/analise-margem2',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseMargem2Form'),
        },
        {
          name: 'detalhe-margem-clientes',
          path: '/analise-margem/margem-cliente',
          component: () => import('@/views/dashboard/forms/Comercial/DetalheMargem/DetalheMargemClientes'),
        },
        {
          name: 'Análise Faturamento',
          path: '/analise-fat',
          component: () => import('@/views/dashboard/forms/Comercial/AnaliseFatForm'),
        },
        {
          name: 'Brinde',
          path: '/brinde',
          component: () => import('@/views/dashboard/forms/Comercial/BrindeForm'),
        },
        {
          name: 'Mix Cliente',
          path: '/mix-cliente2',
          component: () => import('@/views/dashboard/forms/Comercial/MixCliente2Form'),
        },
        {
          name: 'fluxo-caixa2',
          path: '/fluxo-caixa2',
          component: () => import('@/views/dashboard/forms/Financeiro/FluxoCaixa3Form'),
        },
        {
          name: 'detalhe-receber-em-atraso',
          path: '/fluxo-caixa2/detalhe-receber-em-atraso',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheReceberEmAtraso'),
        },
        {
          name: 'detalhe-receber-em-7-dias',
          path: '/fluxo-caixa2/detalhe-receber-em-7-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheReceberEm7Dias'),
        },
        {
          name: 'detalhe-receber-em-14-dias',
          path: '/fluxo-caixa2/detalhe-receber-em-14-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheReceberEm14Dias'),
        },
        {
          name: 'detalhe-receber-em-21-dias',
          path: '/fluxo-caixa2/detalhe-receber-em-21-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheReceberEm21Dias'),
        },
        {
          name: 'detalhe-receber-em-28-dias',
          path: '/fluxo-caixa2/detalhe-receber-em-28-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheReceberEm28Dias'),
        },
        {
          name: 'detalhe-receber-em-35-dias',
          path: '/fluxo-caixa2/detalhe-receber-em-35-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheReceberEm35Dias'),
        },
        {
          name: 'detalhe-pagar-em-atraso',
          path: '/fluxo-caixa2/detalhe-pagar-em-atraso',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalhePagarEmAtraso'),
        },
        {
          name: 'detalhe-pagar-em-7-dias',
          path: '/fluxo-caixa2/detalhe-pagar-em-7-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalhePagarEm7Dias'),
        },
        {
          name: 'detalhe-pagar-em-14-dias',
          path: '/fluxo-caixa2/detalhe-pagar-em-14-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalhePagarEm14Dias'),
        },
        {
          name: 'detalhe-pagar-em-21-dias',
          path: '/fluxo-caixa2/detalhe-pagar-em-21-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalhePagarEm21Dias'),
        },
        {
          name: 'detalhe-pagar-em-28-dias',
          path: '/fluxo-caixa2/detalhe-pagar-em-28-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalhePagarEm28Dias'),
        },
        {
          name: 'detalhe-pagar-em-35-dias',
          path: '/fluxo-caixa2/detalhe-pagar-em-35-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalhePagarEm35Dias'),
        },
        {
          name: 'detalhe-saldo-em-atraso',
          path: '/fluxo-caixa2/detalhe-saldo-em-atraso',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheSaldoEmAtraso'),
        },
        {
          name: 'detalhe-saldo-em-7-dias',
          path: '/fluxo-caixa2/detalhe-saldo-em-7-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheSaldoEm7Dias'),
        },
        {
          name: 'detalhe-saldo-em-14-dias',
          path: '/fluxo-caixa2/detalhe-saldo-em-14-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheSaldoEm14Dias'),
        },
        {
          name: 'detalhe-saldo-em-21-dias',
          path: '/fluxo-caixa2/detalhe-saldo-em-21-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheSaldoEm21Dias'),
        },
        {
          name: 'detalhe-saldo-em-28-dias',
          path: '/fluxo-caixa2/detalhe-saldo-em-28-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheSaldoEm28Dias'),
        },
        {
          name: 'detalhe-saldo-em-35-dias',
          path: '/fluxo-caixa2/detalhe-saldo-em-35-dias',
          component: () => import('@/views/dashboard/forms/Financeiro/DetalheFluxoCaixa2/DetalheSaldoEm35Dias'),
        },
        {
          name: 'magis-entrega',
          path: '/magis-entrega',
          component: () => import('@/views/dashboard/forms/MagisEntrega/MagisEntregaForm'),
        },
        {
          name: 'rastrear-entregas',
          path: '/rastrear-entregas',
          component: () => import('@/views/dashboard/forms/MagisEntrega/RastrearEntregasForm'),
        },
      ],
    },
  ],
})

// Verificação de duplicatas de nomes de rota
const routeNames = new Set()

const routeUrl = new Set()
router.options.routes.forEach(route => {
  route.children.forEach(item => {
    if (item.name) {
      if (routeNames.has(item.name)) {
        alert(`Rota com name duplicados: ${item.name}`)
        throw new Error(`Rota com name duplicados: ${item.name}`)
      }

      routeNames.add(item.name)

      if (routeUrl.has(item.path)) {
        alert(`Rota com url duplicadas: ${item.path}`)
        throw new Error(`Rota com url duplicadas: ${item.path}`)
      }

      routeUrl.add(item.path)
    }
  })
})

router.beforeEach((to, from, next) => {
  if (localStorage.username && localStorage.tokencontrato) {
    var a = 'undefined'
    // if (navigator && navigator.userAgentData && navigator.userAgentData.platform) {
    //   a = navigator.userAgentData.platform
    // } else
    if (navigator && navigator.appVersion) {
      a = navigator.appVersion
    } else {
      a = navigator.userAgent
    }

    service.logacesso(localStorage.username, localStorage.tokencontrato, to.fullPath, a).then(resposta => {
      // if (resposta.data) {
      //   console.log(resposta.data)
      // }
    })
  }
  next()
})

export default router
